// extracted by mini-css-extract-plugin
export default {"main":"b1c5cf491d ffe70e0fb9 bf45c46df4 _0638fee0ac","title":"b5b3cce517"};